import { CustomOperatorValue } from '@aline/common';
import { params } from '@aline/routes';
import type { RepositoryFilter } from '@aline/routes';
import type { GridFilterItem } from '@mui/x-data-grid-premium';
import { omit } from 'lodash';
import type { DocumentStatusFilterItem } from 'src/components/generic/data-grid/custom-operators';
import type { ReportGridRow } from 'src/components/reports/types';
import { Apollo } from 'src/gql/generated';
import { v4 as uuid4 } from 'uuid';

const STATUS_FIELD = 'status' satisfies keyof ReportGridRow;

/** The grid filter each `?filter=` value of the Documents page opens with. */
const REPOSITORY_FILTER_ITEMS: Record<RepositoryFilter, () => GridFilterItem> = {
  signatureDetected: () => ({
    field: STATUS_FIELD,
    id: uuid4(),
    operator: CustomOperatorValue.SignatureDetected,
  }),
  signed: () => getDocumentStatusItem(Apollo.DocumentStatus.Signed),
  templates: () => getDocumentStatusItem(Apollo.DocumentStatus.Template),
};

const REPOSITORY_FILTERS = Object.values(omit(params.repositoryFilter, 'key'));

/** The filter item for a `?filter=` value, or null when there is none or it is unknown. */
export function getRepositoryFilterItem(value: string | null): GridFilterItem | null {
  const filter = REPOSITORY_FILTERS.find(known => known === value);
  return filter ? REPOSITORY_FILTER_ITEMS[filter]() : null;
}

function getDocumentStatusItem(status: Apollo.DocumentStatus): DocumentStatusFilterItem {
  return {
    field: STATUS_FIELD,
    id: uuid4(),
    operator: CustomOperatorValue.DocumentStatus,
    value: [status],
  };
}
